import { ChangeDetectorRef, Component, ComponentRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FlowService } from '@app/flow/shared';
import { environment } from '@env/environment';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { isEmpty } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SessionStorage } from 'ngx-webstorage';
import { Subject, Subscription } from 'rxjs';
import { Actividad } from '../models/actividad.model';
import { Annulation } from '../models/anulacion.model';
import { DocumentoAnexo } from '../models/documento.model';
import { TypeProcess } from '../models/proceso.model';
import { HistorialMicroproceso, Microproceso, Tarea } from '../models/tarea.model';
import { Etapas, Tramite } from '../models/tramite.model';
import { HelperFlowService } from '../services/helper-flow.service';
import { NotifierService } from '../services/notifier.service';
import { FlowTitle } from '../title';
import { Const } from '../util/constants';
import { ProcedureMonitoringConfig } from './shared/procedure-monitoring.config.service';
import { ProcedureMonitoringService } from './shared/procedure-monitoring.data.service';

@Component({
  selector: 'iw-procedure-monitoring',
  templateUrl: './procedure-monitoring.component.html',
  styleUrls: ['./procedure-monitoring.component.scss'],
  providers: [ProcedureMonitoringService]
})
// type Template = "primary";
export class ProcedureMonitoringComponent implements OnInit, OnDestroy {
  messageAlertDynamic = "";
  // Datos de la tabla
  sourceData: LocalDataSource;
  // Contiene la configuracion de la tabla
  settings = {};
  //estructura de la tabla de documentos personalizada
  structure_table: any[] = [];
  //seguimientos del expediente
  data_expedient: any[] = [];
  // row seleccionado por el usuario
  rowSelect: any = {};
  // accion de descargar 
  accion = '';
  // Contiene el radicado del expediente
  @Input() expediente: any = {};
  // Contiene el nombre del tramite
  @Input() tramite: string;
   // Instancia del trámite(default) seleccionado
  // La instancia puede ser un microproceso
  instance: Tramite | Microproceso;
  data: FlowTitle;
  // Muestra diferentes elementos
  show = {
    // Significado de la iconografía del flujo
    helperFlow: false,
    // Formulario de filtros de consulta
    filterForm: false,
  };
  isLoading = {
    listInstances: false,
    createInstance: false,
    showInstance: false,
    finishTask: false,
    startSecondary: false,
    cancelSecondary: false,
    associationTramite: false,
    alertDynamic: false,
  };
  // Contiene el tipo de proceso que se esta renderizando
  typeProcess: TypeProcess = "process";
  // Contiene las etapas del tramite ( etapa actual y general)
  stage: Etapas;
  // Variable que determina si el formualrio está abierto
  openFormPreview: Boolean = false;
  // id secondary
  idSecondary = -1;
  // id secondary
  idTaskSecondary = -1;
   // Contiene el id de la primera actividad activada
   idActivityFirstActive = -1;
  // Contiene la información de anulación
  annulationInfo: Annulation = {};
  extensionsLabel = '';
  extensionsText = '';
  // Contiene los archivos subidos
  attachedDocuments: DocumentoAnexo[] = [];
  // Actividades de la instancia
  private _activities: Actividad[];
  historysMicroproces = {};
  historyMicroproce: HistorialMicroproceso[];
  idHistorySelect = 0;
  idsSelected: any[] = [];
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  isDesign = "compact";
   // Plantilla que muestra el contenido del componente
   private _template: TemplateRef<any>;
   // Referencia de la modal
   private modalRef: BsModalRef;
   // Plantilla que muestra el contenido del componente
   private _templateF: TemplateRef<any>;
   // Suscripción a las notificaciones de los componentes hijos
  notifications: Subscription;
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @SessionStorage() isDesignTaskPreview: string;
  // Controla si la memorai guardada
  private destroy: Subject<void> = new Subject<void>();
  @ViewChild("templatePreviewFlow") primaryTpl: TemplateRef<any>;

  constructor(private drds: ProcedureMonitoringService,
    private hfs: HelperFlowService,
    private fs: FlowService,
    private cdRef: ChangeDetectorRef,
    private modalService: BsModalService,
    private ns: NotifierService,
    private sts: ScrollToService
    ) { }

  ngOnInit() {
    //valida si la tabla es por consulta o fija
    
      this.drds.getDocumentExpedient(this.expediente.idExpediente).subscribe(async res=>{
      if(res){
        this.data_expedient = await res.valores;
        this.data_expedient.forEach(doc=>{
          doc['value'] = true;
        });
        this.structure_table =  await res.estructura;
        this.structure_table = this.structure_table.sort((a,b)=> a.orden - b.orden);
        const configTable = new ProcedureMonitoringConfig(this.structure_table);
        this.settings = configTable.settings;
        configTable.accion.subscribe((res: any) => {
        if(res.action && res.action == "ver_flujo"){
          if(res.data[res.alias] && res.data[res.alias] != -1){
            this.getInstance(res.data[res.alias]);
          }
          }
          else{
            this.actionTable(res.action);
          }
        });
        this.sourceData = new LocalDataSource(this.data_expedient);
      }
      })
      // Escuchar todas las notificaciones de los elementos hijos del flujo
      this.notifications = this.ns.get().subscribe((n) => {
      // Si se ejecutó el evento click en una tarea
      if (n.source === "task-preview" && n.eventTriggered === "click") {
        this.clickedTask(n.data, n.action);
      } else if (n.source === "title-preview" && n.eventTriggered === "change" && n.action === "changeDesign") {
        this.isDesign = this.isDesignTaskPreview ? this.isDesignTaskPreview : "compact";
      }
      });
  }

  ngOnDestroy() {
    // Eliminar suscripción a las notificaciones
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
  }
  actionTable(action: any){
    this.accion = action;
    
  }


   /**
   * Consulta una instancia de un trámite y genera su flujo.
   *
   * @param {number} idInstance
   * @memberof ProcedureMonitoringComponent
   */
    getInstance(idInstance: number, clean: boolean = true) {
        this.isLoading.showInstance = true;
        this.fs
          .getInstance(idInstance)
          .finally(() => {
            this.isLoading.showInstance = false;
          })
          .subscribe(async (instance: Tramite) => {
            this.selectedInstance(instance, false, clean);
            // if(this.searchByProcess){
            //   await this.stcRefProcess.reload("tramite", instance.nombre);
            // }else{
            //   await this.stcRef.reload("tramite", instance.nombre);
            // }
          });
        this.template = "primary";
        this.modalRef = this.modalService.show(
          this.primaryTpl,{ class:  'modal-personalized-form', ignoreBackdropClick: true }
        );
      //Limpiar array de ids seleccionados
      // this.idsSelected = [];
    }

  /**
   * Refresca el flujo actual
   *
   * @memberof ProcedureMonitoringComponent
   */
   refreshFlow() {
    if (this.hfs.flowsHistory.length === 1) {
      this.isLoading.showInstance = true;
      this.fs
        .getInstance(this.hfs.flowsHistory[0])
        .finally(() => {
          this.isLoading.showInstance = false;
        })
        .subscribe((instance: Tramite) => {
          this.selectedInstance(instance, false, false, true);
        });
    } else {
      this.runMicroProcess(this.hfs.flowsHistory[this.hfs.flowsHistory.length - 1], false, false, true);
    }
  }
  set activities(v: Actividad[]) {
    this._activities = this.hfs.refineActivities(v, {
      filterByStatus: "inactive",
    });
  }
  get activities(): Actividad[] {
    return this._activities;
  }

   /**
   * Define la plantilla que se debe mostrar.
   *
   * @memberof ProcedureMonitoringComponent
   */
    set template(tpl: "primary" | TemplateRef<any>) {
      let template: TemplateRef<any>;
      if (!(tpl instanceof TemplateRef)) {
            template = this.primaryTpl;
            
        }
       else {
        template = tpl;
      }
      this._template = template;
      this.cdRef.detectChanges();
    }
  
    get template() {
      return this._template;
    }

    set templateFPreview(tpl: TemplateRef<any>) {
      // let template: TemplateRef<any>;
      // template = tpl;
      this._templateF = tpl;
      this.cdRef.detectChanges();
    }
  
    get templateFPreview() {
      return this._templateF;
    }

    /**
   * Evento que se ejecuta al seleccionar una instancia
   * del trámite por default.
   * - Setea la instancia global usada para generar el flujo.
   * - Setea las actividades del flujo.
   *
   * @param {(Tramite | Microproceso)} instance
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @memberof ProcedureMonitoringComponent
   */
     selectedInstance(
      instance: Tramite | Microproceso,
      goBack: boolean = false,
      clean: boolean = false,
      changeCurrent: boolean = false
    ) {
      this.hfs.updateFlowHistory(instance, goBack, clean, changeCurrent);
      this.instance = instance;
      if (instance && instance.actividades && instance.actividades.length) {
        for (const activity of instance.actividades) {
          if (activity.actividad_estado && activity.actividad_estado.nombre === Const.STATUS_ACTIVITY.pending) {
            this.idActivityFirstActive = activity.id;
            break;
          }
        }
      }
      this.activities = instance.actividades;
      this.data = this.hfs.getFlowTitle(instance);
      this.stage = null;
      this.fs.getStages(this.data.idTramite).subscribe((stage) => {
        if (Object.entries(stage.etapa_actual).length > 0) {
          this.stage = stage;
        }
      });
    }

      /**
   * Consulta un microproceso y crea su flujo.
   *
   * @private
   * @param {(Tarea | number)} task
   * @param {boolean} [goBack=false]
   * @param {boolean} [clean=false]
   * @param {boolean} [changeCurrent=false]
   * @param {boolean} [secondary=false]
   * @memberof ProcedureMonitoringComponent
   */
  private async runMicroProcess(
    task: Tarea | number,
    goBack: boolean = false,
    clean: boolean = false,
    changeCurrent: boolean = false,
    secondary: boolean = false
  ) {
    this.isLoading.showInstance = true;
    let idTask = typeof task === "number" ? task : task.id;
    if (typeof task === "number") {
      idTask = task;
    } else if (task && task.historial_microproceso) {
      let ordenMax = 0;
      task.historial_microproceso.forEach((history) => {
        if (history.orden > ordenMax) {
          ordenMax = history.orden;
          idTask = history.id;
        }
      });
    } else {
      idTask = task.id;
    }
    if (typeof task === "object") {
      if (!this.historysMicroproces[idTask]) {
        this.historysMicroproces[idTask] = task.id;
      }
      this.historyMicroproce = task.historial_microproceso;
    } else {
      if (this.historysMicroproces[idTask]) {
        this.historyMicroproce = await this.fs.getHistoryMicroproces(this.historysMicroproces[idTask]);
        if (this.historyMicroproce && this.historyMicroproce.length) {
          this.historyMicroproce.forEach((history) => {
            if (!this.historysMicroproces[history.id]) {
              this.historysMicroproces[history.id] = this.historysMicroproces[idTask];
            }
          });
        }
      }
    }
    if (this.historyMicroproce && this.historyMicroproce.length) {
      this.historyMicroproce.sort((a, b) => b.orden - a.orden);
    }
    this.idHistorySelect = idTask;
    this.fs
      .getMicroProcess(idTask)
      .finally(() => {
        this.isLoading.showInstance = false;
      })
      .subscribe((instance: Microproceso) => {
        if (secondary) {
          this.idSecondary = instance.id;
        }
        this.selectedInstance(instance, goBack, clean, changeCurrent);
      });
    this.template = "primary";
  }

  cleanFlow(){
    this.instance = null
  }

   /**
   * Se ejecuta cuando detecta una notificación con un
   * evento click de una tarea.
   * - Si la tarea es un microproceso genera su flujo.
   *
   * @private
   * @param {any} data
   * @param {string} action
   * @memberof ProcedureMonitoringComponent
   */
    private clickedTask(data: any, action: string) {
      switch (action) {
        // Cuando se va abrir un formulario fuera de la modal
        case "openFormOutModal":
          // this.backupDataSelectTramiteComponent();
          this.templateFPreview = data.template;
          this.openFormPreview = true;
          setTimeout(() => {
            this.sts.scrollTo({
              target: "headerFlow",
            } as ScrollToConfigOptions);
          });
          break;
        // Mostrar cargar del flujo para accion de finalizar tarea
        case "isLoadingFinishTask":
          this.isLoading.finishTask = true;
          this.openFormPreview = false;
          this.templateFPreview = null;
          break;
        case "isLoadingAssociationTramite":
          this.isLoading.associationTramite = !this.isLoading.associationTramite;
          this.openFormPreview = false;
          this.templateFPreview = null;
          break;
        case "closeLoadingFinishTask":
          this.isLoading.finishTask = false;
          break;
        // // Cuando se va a finalizar la tarea
        // case "finishTask":
        //   this.isLoading.finishTask = false;
        //   this.refreshInstance();
        //   break;
        // Cuando se va abrir un microproceso
        case "runMicroProcess":
          if (!isEmpty(data)) {
            this.runMicroProcess(data.task);
          }
          break;
        // Cuando se va abrir una secundaria
        case "runSecondary":
          this.typeProcess = "secondary_process";
          if (!isEmpty(data)) {
            this.idTaskSecondary = data.task.id;
            this.runMicroProcess(data.task, false, false, false, true);
          }
          break;
        // Cuando se va a cerrar un formulario fuera de la modal
        case "closeTaskForm":
          /*         this.template = 'primary'; */
          this.openFormPreview = false;
          this.templateFPreview = null;
          break;
        // Cuando se necesita actualizar la informacion del flujo
        case "updateTask":
          const activityCurrent: Actividad = this.instance.actividades.find((element: Actividad) => {
            return element.id === data.meta.idActivity;
          });
          activityCurrent.tareas[data.meta.index] = data;
          break;
        // Cuando se necesita refrescar el flujo
        case "refreshFlow":
          this.refreshFlow();
          break;
        // // Cuando se indica que se iniciaria un proceso secundario
        // case "startSecondary":
        //   this.startSecondary(data);
        //   break;
        // // Cuando se ejecuta el auto guardar en tareas
        // case "autoSave":
        //   if (data && data.length) {
        //     this.contextAutoSave = data;
        //     this.finishTaskAutoSave();
        //   } else {
        //     if (this.isLoading.alertDynamic) {
        //       this.messageAlertDynamic = "";
        //       this.isLoading.alertDynamic = false;
        //     }
        //     if (!this.contextAutoSave && !this.contextAutoSave.length) {
        //       this.refreshFlow();
        //     }
        //   }
        //   break;
        // Cuando se desea mostrar la alerta de cargando con un mensaje dinamico
        case "alertLoadDynamic":
          if (data && typeof data === "string") {
            this.messageAlertDynamic = data;
            this.isLoading.alertDynamic = true;
            this.openFormPreview = false;
            this.templateFPreview = null;
          } else {
            this.messageAlertDynamic = "";
            this.isLoading.alertDynamic = false;
          }
          break;
      }
    }

     /**
   * Retrocede un nivel en el flujo.
   *
   * @memberof ProcedureMonitoringComponent
   */
  goBack() {
    if (this.idSecondary > 0) {
      if (this.idSecondary === this.instance.id) {
        this.typeProcess = "process";
        this.idSecondary = -1;
        this.idTaskSecondary = -1;
      }
    }
    this.hfs.returnToPreviousFlow(
      // Generar el flujo de la instancia del trámite
      (idTramite) => {
        this.isLoading.showInstance = true;
        this.fs
          .getInstance(idTramite)
          .finally(() => {
            this.isLoading.showInstance = false;
          })
          .subscribe((instance: Tramite) => {
            this.selectedInstance(instance, true);
            this.typeProcess = "process";
            this.idSecondary = -1;
            this.idTaskSecondary = -1;
          });
      },
      // Generar el flujo con el microproceso
      (idMicroProcess) => this.runMicroProcess(idMicroProcess, true)
    );
    //Limpiar array de ids seleccionados
    this.idsSelected = [];
  }

  closeModalAttached(){
    this.modalRef.hide();
  }
    

}



// WEBPACK FOOTER //
// ./src/app/shared/procedure-monitoring/procedure-monitoring.component.ts